import { call, put, takeEvery } from 'redux-saga/effects'
import { fetchInfo } from 'services/api/referral'

import { actions } from './slice'

const fetchSaga = function* () {
  try {
    const res = yield call(fetchInfo)
    if (res.ok) {
      yield put(actions.setInfo(res.response))
    } else {
      yield put(actions.error())
    }
  } catch (e) {
    yield put(actions.error())
  }
}

const currenciesSagas = function* () {
  yield takeEvery(actions.fetch.type, fetchSaga)
}

export default currenciesSagas
